import {
  buildEditorUrl,
  buildLiveControlUrl,
  buildOutputUrl,
} from '../shared/liveProtocol';

const LIVE_WINDOW_NAME = 'lower-thirds-live-control';
const LIVE_WINDOW_FEATURES = 'popup=yes,resizable=yes,width=1480,height=940';

export const getEditorUrl = () => buildEditorUrl();

export const getLiveUrl = (params = {}) => buildLiveControlUrl(params);

export const getOutputUrl = (params = {}) => buildOutputUrl(params);

export const openOrFocusLiveWindow = (params = {}) => {
  if (typeof window === 'undefined' || typeof window.open !== 'function') return null;
  const liveWindow = window.open(getLiveUrl(params), LIVE_WINDOW_NAME, LIVE_WINDOW_FEATURES);
  liveWindow?.focus?.();
  return liveWindow;
};
